<template>
  <div class="form-container">
    <form @submit.prevent="submit">
      <div class="group-container">
        <template v-for="part in parts">
          <div :key="part.id" class="form-group">
            <label :for="part.name">
              {{ $t(part.label) }}{{ part.required ? '*' : '' }} :
            </label>
            <template v-if="part.formType === 'input'">
              <b-form-input
                v-model="schema[part.name]"
                :id="part.name"
                :type="part.type"
                :placeholder="$t(part.placeholder)"
                :required="part.required"
                :pattern="part.pattern"
              />
            </template>
            <template v-if="part.formType === 'list'">

              <b-dd id="ddown1" :text="$t(part.placeholder)" class="m-md-2" variant="bg-light border-dark">
                <b-dd-item>10 plates : 40€</b-dd-item>
                <b-dd-item>25 plates : 90€</b-dd-item>
                <b-dd-item>50 plates : 150€</b-dd-item>
                <b-dd-divider></b-dd-divider>
                <b-dd-item disabled>For more info contact the admins</b-dd-item>
              </b-dd>

            </template>
            <template v-if="part.formType === 'textearea'">
              <b-form-textarea
                v-model="schema[part.name]"
                :v-autosize="true"
                :placeholder="$t(part.placeholder)"
                :required="part.required"
                :rows="5"
              />
            </template>
          </div>
        </template>
        <div class="form-group">
          <vue-recaptcha :sitekey="siteKey" @verify="onVerify" />
        </div>
      </div>
      <b-button
        variant="primary"
        type="submit"
        block
      >
        <span>{{ $t('actions.send') }}</span>
      </b-button>
    </form>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'FormTypeComponent',
    components: {
      VueRecaptcha,
    },
    props: {
      form: {
        type: String,
        default: 'contact',
      },
      parts: {
        type: Array,
        default() {
          return [];
        },
      },
      success_route: {
        type: [String, Object, Function],
        default: null,
      },
      schema: {
        type: Object,
        default() {
          return {};
        },
      },
      postUri: {
        type: String,
        default: 'public/contact/',
      },
      config: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        siteKey: this.$config.parameters.recaptcha.site_key,
      };
    },
    methods: {
      successRoute() {
        if (typeof this.success_route === 'function') {
          return this.success_route();
        }
        return this.success_route;
      },
      onVerify: function (response) {
        this.schema['g-recaptcha-response'] = response;
      },
      submit() {
        this.$ajax.post(this.postUri, this.schema, this.config)
          .then((data) => {
            if (data.status) {
              this.$notify({
                title: this.$t(`flashes.${this.form}.sent_title`),
                text: this.$t(`flashes.${this.form}.sent`),
                type: 'success',
              });
              this.$router.push(this.successRoute());
            } else {
              this.$notify({
                title: this.$t(`flashes.${this.form}.not_sent_title`),
                text: this.$t(`flashes.${this.form}.not_sent`),
                type: 'error',
              });
            }
          }, (error) => {
            if (error.response.data.status === 'invalid_email') {
              this.$notify({
                title: this.$t(`flashes.${this.form}.not_sent_title`),
                text: this.$t(`flashes.${this.form}.invalid_email`),
                type: 'error',
              });
            } else if (error.response.data.status === 'invalid_captcha') {
              this.$notify({
                title: this.$t(`flashes.${this.form}.not_sent_title`),
                text: this.$t(`flashes.${this.form}.invalid_captcha`),
                type: 'error',
              });
            } else {
              this.$notify({
                title: this.$t(`flashes.${this.form}.server_error_title`),
                text: this.$t(`flashes.${this.form}.server_error`),
                type: 'error',
              });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/FormType.vue